// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateConfirmationModalVisibility = visibility =>

    dispatch => {

        addRemoveModalClass(visibility);

        dispatch({
            type: actions.UPDATE_LABOR_RATE_CONFIRMATION_MODAL_VISIBILITY,
            visibility
        });

    };



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/action-creators/confirmation-modal.js